import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgInformation(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#0763ED" />
      <path
        fill="white"
        fillRule="evenodd"
        d="M13.3599 9.86022C13.3599 8.40219 14.5419 7.22021 15.9999 7.22021C17.458 7.22021 18.6399 8.40219 18.6399 9.86022C18.6399 11.3182 17.458 12.5002 15.9999 12.5002C14.5419 12.5002 13.3599 11.3182 13.3599 9.86022ZM14.3001 15.4001H17.7001V24.4001H14.3001V15.4001Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgInformation);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
